const env = window.location.hostname.replace('mojstart.nn.pl', '');

export const apiPrefix = env === 'localhost' ? '' : `https://${env}k2.nn.pl`;
